import { httpGet, urlConcat, httpPost } from '@/utils/http'
import { API_TENDER } from '@/config'

let reg = null;
const loadRegs = async (p) => {
  let u = urlConcat(API_TENDER, "/common/GetRegionsStructure");
  let resp = await httpGet(u, { id: p && p.key });

  let r = resp.map(a => ({ key: a.Id, hasChildren: a.HasChildren, name: a.Name }));

  let ts = r.filter(a => a.hasChildren).map(async a => {
    let re = await loadRegs(a);

    re.forEach(aa => {aa.parent = a.key; r.push(aa);});
  });

  await Promise.all(ts);
  return r;
};

export async function getReg() {
  let reg = window.sessionStorage.getItem('monitoring.reg');
  if (!reg || reg.length === 0) {
    reg = await loadRegs();
    window.sessionStorage.setItem('monitoring.reg', JSON.stringify(reg));
  }
  else {
    reg = JSON.parse(reg);
  }

  return reg;
}

export async function getPlaces() {
  let u = urlConcat(API_TENDER, "/common/GetRegionsStructureV2");
  let data = await httpGet(u);
  return data;
}

const loadOkpd2 = async (p) => {
  let u = "http://stable-dnn.otc.ru/tenders/common/GetOkpd2sStructure";
  let resp = await httpGet(u, { id: p && p.key });

  let r = resp.map(a => ({ key: a.Id, hasChildren: a.HasChildren, name: `${a.Id} ${a.Name}` }));

  let hasChildren = r.filter(a => a && a.hasChildren);

  if (hasChildren && hasChildren.length > 0) {
    for (let i = 0; i < hasChildren.length; i++) {
      let a = hasChildren[i];
      let re = await loadOkpd2(a);
      a.child = re;
    }
  }

  return r;
};

export async function getOkpd2sStructure() {
  let okpd2 = window.sessionStorage.getItem('monitoring.okpd2');

  if (!okpd2 || okpd2.length === 0) {
    okpd2 = await loadOkpd2();
    window.sessionStorage.setItem('monitoring.okpd2', JSON.stringify(okpd2));
  }
  else {
    okpd2 = JSON.parse(okpd2);
  }

  return okpd2;
}

const loadDicts = async () => {
  let u = urlConcat(API_TENDER, "/api/order/GetMonitoringDictionaries");
  let resp = await httpGet(u);

  let r = resp.Marketplaces.map(a => ({ key: a.id, name: a.label, child: a.children.map(c => ({ key: c.id, name: c.label })) || null }));

  if (resp.PurchaseMethods && resp.PurchaseMethods['1000']) {
    delete resp.PurchaseMethods['1000'];
  }

  let data = {
    "currencyCodes": resp.CurrencyCodes,
    "dictSections": [...r],
    "purchaseMethods": resp.PurchaseMethods
  };

  return data;
};
export async function getDicts() {
  let dicts = window.sessionStorage.getItem('monitoring.dicts');
  if (!dicts || dicts.length === 0) {
    dicts = await loadDicts();
    window.sessionStorage.setItem('monitoring.dicts', JSON.stringify(dicts));
  }
  else {
    dicts = JSON.parse(dicts);
  }

  return dicts;
}

export async function suggestCompany(term) {
  const responseData = await httpGet(urlConcat(API_TENDER, '/Search/OrganizationAutocomplete'), { term });

  return responseData.map(function(x){
    return {
      id: x.Id,
      name: x.Name,
      inn: x.Inn,
      kpp: x.Kpp,
      innKpp: x.InnKpp
    };
  });
}

const loadOrgNames = async () => {
  return await httpGet(urlConcat(API_TENDER, "/common/GetOrganizationNames"));
};

export async function getOrgNames() {
  let result = window.sessionStorage.getItem('monitoring.orgnames');

  if (!result || result.length === 0) {
    result = await loadOrgNames();
    window.sessionStorage.setItem('monitoring.orgnames', JSON.stringify(result));
  }

  return result;
}

export async function parseFilterFromUrl(url) {
  return await httpPost(urlConcat(API_TENDER, '/seo/parseurl'), { url }, {ttl: 1000 * 60 * 60});
}
